import React from 'react';
import './styles.scss';

interface Props {
    fullscreen: boolean;
    path?: string;
    onCloseImage: () => void;
}

const FullScreenImageModal = (props: Props) => {
    const { fullscreen, path, onCloseImage } = props;

    return (
        <div className={`image-modal ${fullscreen ? 'show-image-modal' : 'hide-image-modal'}`} id="imagePathModal">
            <span className="close" onClick={onCloseImage}>
                &times;
            </span>
            <img className="image-modal-content" id="image" src={path} />
        </div>
    );
};

export default FullScreenImageModal;
